import React from "react";
import { PublisherAddress } from "./PublisherAddress";
export var NewPublisherAddressSection = function (_a) {
    var _b;
    var control = _a.control, errors = _a.errors, setValue = _a.setValue, regionsData = _a.regionsData;
    var regions = (_b = regionsData === null || regionsData === void 0 ? void 0 : regionsData.items) !== null && _b !== void 0 ? _b : [];
    return (React.createElement(PublisherAddress, { type: "mainAddress", control: control, errors: errors, regions: regions, setValue: setValue, addressFieldsRequired: false }));
};
